export default {
  page: {
    title: {
      base: 'Betalingsgateway Autopay',
      start: 'Een betaalmethode kiezen',
      result: 'Terugkerende BLIK-betaling',
      visadata: 'VisaMobiel',
      continue: 'Doorgaan - Een betaalmethode kiezen',
      wait: 'Wachten',
      confirmation: 'Betalingsbevestiging',
      thankYou: 'Bedankt voor de betaling',
      error: 'Websitefout',
      errorNotFound: 'Pagina niet gevonden',
      secureBack: 'Lader',
      maintenance: 'Onderhoud',
      regulationsApproval: 'Regelgeving en privacybeleid',
      toTransferData: 'overdrachtsgegevens',
      sessionTimeout: 'Pagina na het einde van de sessie',
      paywayError: 'Betaalkanaal niet beschikbaar'
    }
  },
  header: {
    availabilityAdjust: {
      increaseFontSize: 'Vergroot de lettergrootte',
      decreaseFontSize: 'Verklein de lettergrootte',
      changeContrast: 'Verander het contrast',
      changeLanguage: 'Wijzig de sitetaal',
      skipToContent: 'Ga naar de inhoud',
      skipToContentLabel: 'Ga naar de hoofdinhoud',
      logoTitle: 'Betalingsgateway Autopay',
      langLoading: 'Taal laden',
      langChanged: 'Taal is gewijzigd'
    },
    sessionTimer: {
      timeOut: 'Sessie verlopen',
      sessionEnd: 'Einde sessie over:',
      label: 'Verleng de sessietijd',
      button: 'Verlengen'
    }
  },
  footer: {
    text2: {
      part1: 'De verwerkingsverantwoordelijke van de persoonsgegevens is Autopay',
      part2: '6 Powstańców Warszawy-straat, 81-718 Sopot. Het verstrekken van persoonsgegevens is vrijwillig, maar noodzakelijk om de ingediende aanvraag te kunnen voltooien. De wettelijke basis, het doel, de periode van de verwerking van persoonlijke gegevens en de rechten van de gebruiker, evenals andere belangrijke informatie over de principes van de verwerking van persoonlijke gegevens, worden gedetailleerd gedefinieerd in <a href="{privacyPolicyUrl}" class="footer-text-link" target="_blank" title="Ga naar de pagina met het privacybeleiddocument (128 KB, PDF)" rel="noreferrer">het privacybeleid van Autopay S.A.</a>'
    },
    linkShowMoreTitle: 'Toon meer informatie',
    linkShowMoreText: 'Lees meer',
    linkShowLessTitle: 'Toon minder informatie',
    linkShowLessText: 'Lees minder',
    help: {
      text1: 'Hulp nodig?',
      text2: 'Heb je vragen over online betalingen?',
      text3: '<a title="Opent in een nieuw venster" href="https://pomoc.autopay.pl/?pk_campaign=paywall&pk_kwd=start&pk_medium=hyperlink" class="footer-text-link" target="_blank" rel="noreferrer">Ga naar de helppagina</a>'
    }
  },
  paywall: {
    header: 'Kies een betaalmethode',
    info: {
      paywayNotAvailable: 'Het spijt ons, maar het lijkt erop dat de door u gekozen betaalmethode op dit moment niet mogelijk is op uw apparaat.',
      applePayNotAvailable: 'Het spijt ons, maar het lijkt erop dat betalen met Apple Pay momenteel niet mogelijk is op uw apparaat.',
      googlePayNotAvailable: 'Het spijt ons, maar het lijkt erop dat betalen met Google Pay momenteel niet mogelijk is op uw apparaat.'
    },
    paywayGroup: {
      inactiveMessage: 'Betaling is momenteel niet mogelijk',
      notice: {
        novelty: 'NIEUW',
        promotion: 'BEVORDERING',
        recommended: 'AANBEVOLEN',
        mastercard: 'SNEL EN VEILIG',
        mastercardC2P: 'SNEL EN VEILIG',
        blik: 'BLIKOMANIA – registreer en win diamanten!',
        visaMobile: 'Betaal vlot en veilig'
      },
      bank: {
        many: 'banken',
        one: 'bank',
        two: 'banken'
      },
      wallet: {
        many: 'portemonnees',
        one: 'portemonnee',
        two: 'portemonnees'
      },
      otp: {
        many: 'manieren',
        one: 'manier',
        two: 'manieren'
      },
      blikPayLater: {
        text1: 'Koop nu, betaal binnen 30 dagen – zonder extra kosten. Door de BLIK-code in te voeren, kunt u een winkellimiet krijgen van maximaal PLN 4.000.',
        text2: 'Dienst beschikbaar bij:'
      },
      blikAuto: {
        bankList: 'Dienst beschikbaar in:',
        infoModel0: 'Volgende betalingen worden automatisch van uw rekening afgeschreven.',
        infoModelM: 'Voor daaropvolgende betalingen is alleen bevestiging in de aanvraag van uw bank vereist.'
      }
    },
    paywayList: {
      label: 'Betalingstypegroep',
      linkSelectOther: 'Selecteer anders'
    },
    paywaySingle: {
      accountAtAnotherBank: 'Ik heb een rekening bij een andere bank'
    },
    paywaySwitch: {
      methodShortSingle: 'Wegwerpbaar',
      methodLongSingle: 'Eenmalige betalingen',
      methodShortAuto: 'Terugkerend',
      methodLongAuto: 'Terugkerende betalingen'
    },
    form: {
      payway: {
        label: 'Kies uw betaalmethode',
        flowLabel: 'Betaalmethode'
      },
      card: {
        label: 'Voer kaartgegevens in',
        flowLabel: 'Betaalkaart',
        iframe: {
          title: 'Het formulier met creditcardgegevens moet worden ingevuld'
        }
      },
      visaMobile: {
        flowLabel: 'Telefoonnummer',
        iframe: {
          title: 'Formulier met telefoonnummer in te vullen'
        },
        status: {
          pending: {
            statusText: 'In afwachting van bevestiging',
            header: 'Bevestig de betaling in de app',
            descriptionText1: 'U kunt de betaling bevestigen in de Visa Mobile-app of een bankapp waarbij Visa Mobile is geactiveerd',
            descriptionText2: 'Nadat je de transactie in de app hebt bevestigd, wacht je op het betaalresultaat',
            descriptionText3: 'Transactieannulering in behandeling',
            cancelButton: 'Betaling annuleren'
          },
          success: {
            statusText: 'Bedankt voor het doen van een aankoop!',
            descriptionText: 'Betaling succesvol afgerond'
          },
          error: {
            statusText: 'Zorg ervoor dat er voldoende saldo op de betaalkaart staat die u gebruikt voor de Visa Mobile-betaling.',
            descriptionText: 'Betaling afgewezen'
          }
        },
        apps: 'Apps die Visa Mobile-betalingen ondersteunen',
        help: 'Heeft u hulp nodig?',
        info: 'Meer informatie',
        secure: 'Veilige betaling met SSL-codering',
        modal2: {
          header: 'Om de betaling te bevestigen, opent u de Visa Mobile-app of de app van de bank waar u Visa Mobile heeft geactiveerd',
          listText1: 'U heeft Visa Mobile geïnstalleerd of Visa Mobile actief in de mobiele app van uw bank',
          listText2: 'u hebt meldingen ingeschakeld in Visa Mobile of een bankapp waarin Visa Mobile is ingeschakeld',
          listText3: 'het nummer dat u heeft opgegeven is correct: <strong class="no-wrap">+{prefix} {phone}</strong>',
          listText4: 'Zorg er ook voor dat...'
        }
      },
      click2pay: {
        loaderText: 'We zijn op zoek naar uw e-mailadres<br> in <strong>Click to Pay</strong>',
        saveCard: {
          text1: 'Bewaar uw kaart',
          text2mc: 'Uw gegevens worden veilig opgeslagen in <strong>Mastercard Click to Pay</strong>',
          text2visa: 'Uw gegevens worden veilig opgeslagen bij <strong>Visa Click to Pay</strong>',
          link: 'Meer informatie'
        },
        email: {
          labelForClick2Pay: 'E-mailadres voor betalingsmeldingen'
        },
        cardSelect: {
          selected: 'Gekozen',
          select: 'Selecteer',
          payOther: 'Voer uw kaartgegevens in',
          back: 'Rug'
        },
        cardSelected: {
          header: 'Gebruik een kaart die is opgeslagen in Click to Pay',
          date: 'geldig tot',
          buttonChange: 'Wijziging'
        },
        codeForm: {
          description: 'We hebben uw e-mailadres gevonden in Click to Pay.',
          codeSentEmail: 'Voer de eenmalige code in die we naar {email} hebben gestuurd om in te loggen op uw account.',
          codeSentPhone: 'Voer de eenmalige sms-code in die we naar {phone} hebben gestuurd om in te loggen op uw account.',
          codeSent: 'Voer de eenmalige code in die we naar {validationChannel} hebben gestuurd om in te loggen op uw account.',
          codeLabel: 'Voer code in',
          codePlaceholder: 'code invoeren',
          codeLabelFlow: 'Code',
          codeSendLabel: 'Stuur nieuwe code',
          codeSendAriaLabel: 'via',
          codeSendAriaLabel2: 'of',
          buttonSendNewSms: 'SMS',
          buttonSendNewEmail: 'e-mail',
          trustedLabel: 'Voeg dit apparaat toe aan uw vertrouwde lijst<br> <span>De volgende keer herkennen we dit apparaat en kunt u betalen zonder in te loggen</span>',
          buttonSubmit: 'Volgende',
          buttonChangeCard: 'Voer uw kaartgegevens in'
        },
        info: {
          description: 'Kaartbetalingen zijn gecodeerd en veilig. De transactie wordt geautoriseerd met behulp van 3DSecure op de website van de bank.'
        },
        loginForm: {
          emailLabel: 'Voer uw e-mailadres in om in te loggen bij Click to Pay',
          emailPlaceholder: 'e-mailadres',
          emailLabelFlow: 'E-mailadres',
          buttonSubmit: 'Inloggen',
          buttonBack: 'Rug'
        },
        newUserForm: {
          header: 'Bewaar kaart in Click to Pay',
          description: 'Om uw kaart te kunnen opslaan, hebben wij nog een aantal gegevens nodig.',
          emailLabel: 'Voer een e-mailadres in',
          emailPlaceholder: 'e-mailadres',
          emailLabelFlow: 'E-mailadres',
          countryLabel: 'Land',
          firstnameLabel: 'Naam',
          firstnamePlaceholder: 'naam',
          firstnameLabelFlow: 'Naam',
          lastnameLabel: 'Achternaam',
          lastnamePlaceholder: 'achternaam',
          lastnameLabelFlow: 'Achternaam',
          phoneLabel: 'Telefoonnummer',
          phonePlaceholder: 'telefoonnummer',
          phoneLabelFlow: 'Telefoon',
          countryCodePlaceholder: 'code',
          countryCodeLabelFlow: 'Code',
          trustedLabel: 'Voeg dit apparaat toe aan uw vertrouwde lijst<br><span>De volgende keer zullen we dit apparaat herkennen en betaalt u zonder in te loggen</span>',
          termsMastercardLabel: 'Als u doorgaat, accepteert u de <a href="https://www.mastercard.com/global/click-to-pay/country-listing/terms.html" target="_blank">Gebruiksvoorwaarden</a> en begrijpt u dat uw gegevens worden verwerkt in overeenstemming met het <a href="https://www.mastercard.com/global/click-to-pay/country-listing/privacy.html" target="_blank">privacybeleid</a> van Mastercard.',
          termsVisaLabel: 'Als u doorgaat, accepteert u de <a href="{c2pVisaTermsUrl}" target="_blank">Servicevoorwaarden van Visa Solution</a> en begrijpt u dat uw gegevens worden verwerkt in overeenstemming met het <a href="{c2pVisaPrivacyUrl}" target="_blank">Visa Privacybeleid</a>.',
          cookieVisaLabel: 'Als u doorgaat, accepteert u het <a href="{c2pVisaCookieUrl}" target="_blank">Visa Cookiebeleid</a>.',
          c2pInfo: 'Uw e-mailadres of mobiele nummer wordt gebruikt om u te verifiëren. Er kunnen bericht-/datatarieven van toepassing zijn.',
          buttonSubmit: 'Bespaar en betaal',
          buttonBack: 'Betaal zonder uw kaart op te slaan'
        },
        profile: {
          header: 'Log in op Click to Pay',
          buttonChangeEmail: 'Wijzig e-mailadres'
        },
        modal: {
          title: 'Klik om te betalen - informatie',
          header: 'Betaal snel en veilig zonder uw kaartgegevens opnieuw in te voeren in de nieuwe Click to Pay-standaard',
          text1: 'Wanneer u met een kaart betaalt, zoek dan naar het logo <img src="/web/img/click2pay/Click_to_Pay.svg" style="height: 14px" alt="Click to Pay Logo"> en betaal snel en gemakkelijk met uw kaartbetaling.',
          text2: 'Click To Pay is een nieuwe standaard voor kaartbetalingen die wordt ondersteund door Visa en Mastercard.',
          text3: 'U kunt de kaart op uw Click to Pay-account gebruiken om te betalen in winkels in Polen en in het buitenland, zonder uw kaartgegevens opnieuw in te voeren.',
          text4: 'De gegevens worden veilig opgeslagen in Visa of Mastercard. Alle informatie is volledig gecodeerd.',
          text5: 'Bij toekomstige betalingen herkent Click to Pay uw e-mailadres, zodat u direct kunt betalen met uw opgeslagen kaarten.',
          text6: 'Bovendien bevestigt u alle betalingen met uw bank, wat volledige veiligheid garandeert.',
          processError: 'Er is een fout opgetreden tijdens het verwerken van uw Click to Pay-betaling. Voer een standaardkaartbetaling uit.'
        }
      },
      email: {
        label: 'Geef uw e-mailadres op',
        flowLabel: 'E-mailadres',
        tip: 'We hebben uw e-mailadres nodig zodat we u berichten kunnen sturen over uw betalingsstatus.',
        fuse: 'Zorg ervoor dat uw e-mailadres correct is ingevoerd.'
      },
      blikCode: {
        label: 'Enter BLIK code',
        flowLabel: 'BLIK code'
      },
      terms: {
        header: 'Toestemmingen en verklaringen',
        selectAll: 'Selecteer alles',
        fieldNotRequired: 'Optioneel veld',
        partnerMarketingTextLess: 'Wilt u e-mail-, sms- of telefonische waarschuwingen van ons ontvangen over de beste aanbiedingen, promoties, wedstrijden en andere interessante evenementen die door ons of onze partners worden georganiseerd?',
        partnerMarketingTextMore: 'Wij beloven niet te spammen! Als u zich verveelt met onze berichten, kunt u uw toestemming op elk gewenst moment intrekken.',
        tradeMarketingTextLess: 'Wilt u dat wij uw e-mailadres of telefoonnummer doorgeven aan onze vertrouwde partners, zodat zij u kunnen voorzien van interessante informatie en aanbiedingen?',
        tradeMarketingTextMore: 'We zorgen ervoor dat onze partners gerenommeerde bedrijven zijn die, net als wij, niet van spammen houden, en u kunt uw toestemming op elk gewenst moment intrekken.'
      },
      termsFlowLabel: 'Regelgeving',
      termsLabelDefault: 'Ik heb de <a href="{regulationUrl}" class="form-text-link" target="_blank" title="Download het servicevoorwaardenbestand" rel="noreferrer">Voorwaarden voor de betalingsservice</a> en het <a href="{privacyPolicyUrl}" class="form-text-link" target="_blank" title="Download het privacybeleidsbestand van Autopay">Privacy Beleid</a>. Ik wil dat de dienst onmiddellijk wordt uitgevoerd en in geval van herroeping van het contract weet ik dat ik geen vergoeding krijg voor de kosten die zijn gemaakt voor de diensten die op mijn verzoek zijn geleverd vóór mijn herroeping van het contract.',
      termsReccuring: 'Als u een betaling wilt uitvoeren, accepteer dan de <a href="{regulationUrl}" class="form-text-link" target="_blank" title="Download het servicevoorwaardenbestand" rel="noreferrer">Servicevoorwaarden</a> en <a href="{privacyPolicyUrl}" class="form-text-link" target="_blank" title="Download het privacybeleidsbestand van Autopay S.A.">Privacy Beleid</a> Autopay S.A., toestemming voor onmiddellijke betalingsservice en toestemming om mijn betaalkaart te belasten.',
      termsReccuringMore1: 'Ik ga ermee akkoord dat de dienst onmiddellijk wordt verleend en ik erken dat ik in geval van herroeping van het contract geen vergoeding krijg voor eventuele kosten die zijn gemaakt voor de diensten die op mijn verzoek zijn geleverd vóór mijn herroeping van het contract.',
      termsReccuringMore2: 'Ik ga er hierbij mee akkoord dat Autopay S.A. op periodieke basis kosten in rekening brengt op mijn betaalkaart om de transactie ten behoeve van {receiverName} uit te voeren. De voorwaarden voor terugkerende kaartbetalingen worden gedefinieerd door de <a href="{regulationUrl}" class="form-text-link" target="_blank" title="Download het servicevoorwaardenbestand" rel="noreferrer">Voorwaarden voor betalingsservice</a>. Ik verklaar hierbij dat ik de termijnen, frequentie en regels ken voor het bepalen van de bedragen die op mijn betaalkaart worden afgeschreven, evenals de manier waarop ik deze toestemming kan intrekken, die door mij zijn vastgelegd bij {receiverName}. Ik neem contact op met {receiverName} voor eventuele vragen over de terugkerende afschrijvingen op de betaalkaart.',
      mwfClauseLess: 'Als u een betaling wilt uitvoeren, accepteer dan de <a href="{regulationUrl}" class="form-text-link" target="_blank" title="Download het bestand met de Servicevoorwaarden" rel="noreferrer">algemene voorwaarden</a> en <a href="{privacyPolicyUrl}" class="form-text-link" target="_blank" title="Download het bestand met het Autopay S.A. Privacybeleid">privacy beleid van Autopay S.A.</a>, stem in met het starten van een transactie bij uw bank via Autopay S.A. en verstrek de details van deze transactie aan de ontvanger en verzoek om onmiddellijke uitvoering van de betalingsdienst.',
      mwfClauseMore: 'Ik wil dat de dienst onmiddellijk wordt verleend en ik weet dat ik bij herroeping van het contract geen restitutie krijg van de gemaakte kosten.',
      mwfClauseARIA: 'Als u een betaling wilt uitvoeren, accepteer dan de algemene voorwaarden en het privacybeleid van Autopay S.A., geef toestemming om een ​​transactie bij uw bank te starten via Autopay S.A., geef details van deze transactie aan de ontvanger en verzoek om onmiddellijke uitvoering van de betalingsdienst. Ik wil dat de dienst onmiddellijk wordt verleend en ik weet dat ik bij herroeping van het contract geen restitutie krijg van de gemaakte kosten. <a href="{regulationUrl}" class="form-text-link" target="_blank" title="" rel="noreferrer" tabindex="-1">Download het bestand met de Servicevoorwaarden</a> <a href="{privacyPolicyUrl}" class="form-text-link" target="_blank" title="" tabindex="-1">Download het bestand met het Privacybeleid van Autopay S.A.</a>',
      paymentInfo: 'De betalingsopdracht wordt via Autopay S.A., gevestigd in Sopot, naar uw bank verzonden en verwerkt volgens de voorwaarden van uw bank. Nadat u uw bank heeft geselecteerd, geeft u toestemming voor de betaling.',
      changePaywayLink1: 'Dat kan nog steeds',
      changePaywayLink2: 'de betalingsvorm wijzigen',
      linkMore: 'MEER',
      linkShowMoreTitle: 'Geef aanvullende informatie weer',
      linkLess: 'MINDER',
      linkShowLessTitle: 'Aanvullende informatie verbergen',
      submitButton: {
        visaMobile: 'Betaal per',
        fastTransfer: 'Genereer overdrachtsgegevens',
        mwf: 'Ik accepteer en betaal',
        pis: 'Ik accepteer en begin met betalen',
        auto: 'Terugkerende betaling bestellen',
        autoPayment: 'Betaling bestellen',
        other: 'Betaal nu',
        orange: 'Bevestigen',
        c2pNext: 'Volgende',
        c2pAccept: 'Ik accepteer',
        c2pSaveAndPay: 'Bespaar en betaal',
        ariaLabelInactive: 'Vul de verplichte velden correct in om verder te gaan'
      }
    },
    frData: {
      pageTitle: 'Gedetailleerde gegevens voor de overdracht',
      header: 'Bestel de overschrijving met behulp van de opgegeven gegevens',
      nrbLabel: 'Ontvangeraccount',
      nameLabel: 'Naam van ontvanger',
      addressLabel: 'Adres van ontvanger',
      titleLabel: 'Naam overdragen',
      amountLabel: 'Bedrag overmaken',
      timeLabel: 'Voer transactie uit via',
      linkCopy: 'Kopiëren',
      linkGetPdf: 'Download PDF met gegevens',
      linkGetPdfTitle: 'Het wordt geopend in een nieuw venster',
      linkGoToBank: 'Log in bij de bank',
      info: 'Log in op uw bankrekening. Kopieer de gegevens naar de overschrijving. Het is belangrijk dat de gegevens hetzelfde zijn, verander het bedrag, de valuta of de titel, enz. niet.',
      verifyInfo: 'De verificatie voor uw bank kan tot 3 dagen duren omdat er geen snelle overboeking kan worden verwerkt. U kunt doorgaan of u kunt uw bankrekening op een andere manier verifiëren. Als je een andere methode wilt kiezen, klik dan op <strong>{backToShopText}</strong> en keer terug naar de Fortuna website.'
    },
    frInfo: {
      paywall: {
        text1: 'Betaalt u vanaf een buitenlandse rekening?',
        text2: 'Zorg ervoor dat het over te maken bedrag en het doel overeenkomen met de verstrekte informatie. Vergeet niet de kosten van uw bank mee te rekenen. Onjuiste informatie kan ertoe leiden dat de betaling de verkoper niet bereikt.'
      },
      frData: {
        text1: 'Voer de gegevens exact in - geen wijzigingen.',
        text2: 'Een ander bedrag of omschrijving van de overschrijving zal ertoe leiden dat de betaling niet aan de bestelling wordt toegewezen.'
      }
    },
    processing: {
      pageTitle: 'Wachtpagina voor transactieverwerking',
      loaderAnimation: 'Animatie weergegeven tijdens de wachttijd',
      header: 'We bereiden uw betalingspagina voor.',
      description: 'Een moment geduld a.u.b....',
      info: {
        header: 'Opmerking!',
        description: 'Sluit de pagina niet na het voltooien van de transactie, anders wordt uw geld niet naar de ontvanger verzonden.'
      },
      loaderText: 'Gegevensoverdracht wordt uitgevoerd.<br>Het duurt maximaal 30 seconden.'
    },
    paymentBoost: {
      button: 'meer betaalmethoden weergeven'
    }
  },
  thankYou: {
    pageTitle: 'Informatie over het resultaat van de transactie',
    form: {
      emailLabel: 'E-mail',
      buttonSubmit: 'Terug naar partnerpagina'
    },
    negative: {
      header: 'De betaling is niet verwerkt vanwege een gebrek aan autorisatie van de transactie.',
      description: 'Als u toch gebruik wilt maken van het aanbod van een bepaalde detailhandelaar of dienstverlener, ga dan terug naar hun website, selecteer het product of de dienst en voer de betaling uit met de methode van uw keuze.'
    },
    pending: {
      header: 'Bedankt voor het bestellen van betaling via betalingsgateway',
      description: 'Verificatie van de transactiestatus is bezig. Zodra het proces is voltooid, ontvangt u informatie over de status van uw betaling in uw e-mailinbox.'
    },
    positive: {
      header: 'Bedankt, uw betaling is verwerkt.',
      description: 'Wij sturen een bevestiging naar het door u opgegeven e-mailadres.'
    }
  },
  regulationsApproval: {
    header: 'Accepteer de transactie'
  },
  wait: {
    pageTitle: 'Wachtpagina'
  },
  sessionTimeout: {
    pageTitle: 'Pagina na het einde van de sessie',
    header: 'De tijd voor het voltooien van de betaling is verstreken',
    description: 'U kunt op elk moment terugkeren naar de site van de partner, opnieuw bestellen of de service gebruiken en betalen via de door u gekozen methode.'
  },
  paywayError: {
    pageTitle: 'Het geselecteerde betaalkanaal is niet beschikbaar',
    header: 'Helaas is de geselecteerde betaalmethode momenteel niet beschikbaar.',
    description: 'Ga terug naar de partnerpagina en probeer het later opnieuw.'
  },
  loader: {
    loading: 'Laden',
    rateLimitExceeded: 'Er is meer transactieverkeer, waardoor het verwerken van uw betaling langer kan duren dan normaal. Een ogenblik geduld en vernieuw de betalingspagina niet.'
  },
  result: {
    pending: {
      header: 'Bevestig terugkerende BLIK-betaling',
      description: 'Open uw bankapp en bevestig de betaling'
    },
    positive: {
      initWithPayment: {
        header: 'Betaald',
        description: 'Wij hebben uw geld overgemaakt naar de ontvanger. De definitieve bevestiging van de activering van BLIK Recurring Payment ontvangt u van de webwinkel of dienstverlener.',
        button: 'Keer terug naar de locatie'
      },
      initWithRefund: {
        header: 'Klaar',
        description1: 'Wij hebben uw bestelling ontvangen en doorgestuurd voor verwerking. De definitieve bevestiging ontvang je rechtstreeks van de winkel.',
        description2: 'Het bedrag van {amount} {currency} wordt teruggestort op uw bankrekening.',
        button: 'Keer terug naar de locatie'
      },
      initWithoutPayment: {
        header: 'Klaar',
        description: 'We maken terugkerende BLIK-betalingen mogelijk. U ontvangt binnenkort informatie van {shopName}.',
        button: 'Keer terug naar de locatie'
      }
    },
    negative: {
      recurrencyNotSupported: {
        header: 'Kan BLIK terugkerende betaling niet inschakelen',
        description1: 'U kunt BLIK terugkerende betalingen niet inschakelen. Deze methode is momenteel niet beschikbaar voor gebruikers van uw bank.',
        description2: 'Probeer het opnieuw met een BLIK-code bij ondersteunde banken of kies een andere betaalmethode.',
        buttonContinue: 'Betaalmethode wijzigen',
        buttonReturn: 'Keer terug naar de locatie'
      },
      wrongTicket: {
        header: 'Incorrect BLIK code',
        description: 'De ingevoerde BLIK-code is onjuist of verlopen. Controleer de code en probeer het opnieuw. Als het probleem zich blijft voordoen, genereer dan een nieuwe code in uw bankapp.',
        buttonContinue: 'Betaalmethode wijzigen',
        buttonReturn: 'Keer terug naar de locatie'
      },
      generic: {
        header: 'Kan BLIK terugkerende betaling niet inschakelen',
        description: 'U kunt BLIK terugkerende betalingen niet inschakelen. Probeer het opnieuw met een BLIK-code bij ondersteunde banken of kies een andere betaalmethode.',
        buttonContinue: 'Betaalmethode wijzigen',
        buttonReturn: 'Keer terug naar de locatie'
      }
    },
    pageTitle: 'Terugkerende BLIK-betaling'
  },
  orderDetails: {
    header: 'Details',
    headerAriaLabel: 'Transactiegegevens',
    amountLabel: 'Verschuldigd bedrag',
    receiverLabel: 'Ontvanger',
    orderLabel: 'Bestelnummer',
    amountOriginalCurrencyLabel: 'Oorspronkelijk bedrag',
    currencyRateLabel: 'Wisselkoers',
    feeLabel: 'Transactiekosten',
    feeLabelDcc: 'Valutaconversiekosten',
    customerNumberLabel: 'Klantnummer',
    invoiceNumberLabel: 'Factuurnummer',
    accountNumberLabel: 'Rekeningnummer',
    paywayLabel: 'Betaalmethode',
    paywayName: 'Online bankoverschrijving',
    linkBack: 'Terug naar winkel',
    linkBackTitle: 'Verlaat de transactie en ga terug naar de winkel',
    linkMore: 'laat meer zien',
    linkLess: 'minder laten zien',
    toggleBtnUnfoldAriaLabel: 'Vouw de bestelgegevens uit',
    toggleBtnFoldAriaLabel: 'Bestelgegevens samenvouwen',
    blikReccuringNameLabel: 'Naam',
    blikReccuringValidToLabel: 'Vervaldatum',
    blikReccuringValidToText: 'Voor onbepaalde tijd',
    blikReccuringFrequencyLabel: 'Frequentie',
    blikReccuringFrequencyText: 'Elke keer dat u de dienst gebruikt'
  },
  error: {
    pageTitle: 'Foutpagina',
    linkBackUrlSet: 'Keer terug naar de partnersite',
    linkBackUrlNotSet: 'Ga naar de helppagina',
    sessionTimeout: {
      title: 'De tijd voor het voltooien van de betaling is verstreken',
      message: 'U kunt op elk moment terugkeren naar de site van de partner, opnieuw bestellen of de service gebruiken en betalen via de door u gekozen methode.'
    },
    notFoundError: {
      pageTitle: 'Foutpagina 404 - pagina niet gevonden',
      title: 'Het lijkt erop dat u te ver bent gevaren en de pagina die u wilt bezoeken niet kunt vinden.',
      message: 'Mogelijke oorzaken: de pagina bestaat niet of is verwijderd, er is onderhoud gaande, het paginaadres is onjuist, er is een technische fout opgetreden.'
    },
    generalError: {
      title: 'Sorry',
      message: 'Momenteel kunnen wij uw overboeking niet verwerken.'
    },
    errFieldNotFound: {
      title: 'Sorry',
      message: ''
    },
    errBadClientSource: {
      title: 'Sorry',
      message: ''
    },
    nrParametersError: {
      title: 'Sorry',
      message: 'Momenteel kunnen wij uw overboeking niet verwerken.'
    },
    transactionOutdated: {
      title: 'De tijd voor het voltooien van de betaling is verstreken.',
      message: 'Bestel hem opnieuw.'
    },
    linkValidityTimeOutdated: {
      title: 'De tijd voor het voltooien van de betaling is verstreken.',
      message: 'Bestel hem opnieuw.'
    },
    transactionValidityTimeOutdated: {
      title: 'De tijd voor het voltooien van de betaling is verstreken.',
      message: 'Bestel hem opnieuw.'
    },
    multiplyTransaction: {
      title: 'Sorry',
      message: 'De transactie bestaat al en wacht op betaling.'
    },
    transactionCanceled: {
      title: 'Sorry',
      message1: 'De transactie is geannuleerd.',
      message2: 'Bestel hem opnieuw.'
    },
    multiplyPaidTransaction: {
      title: 'Sorry',
      message: 'De transactie is al betaald.'
    },
    transactionReject: {
      title: 'Sorry',
      message1: 'Oeps, er is iets misgegaan.',
      message2: 'Er wordt gewerkt aan een oplossing...'
    },
    bankDisabled: {
      title: 'Sorry',
      message: 'De geselecteerde bank is momenteel niet beschikbaar.'
    },
    bankTemporaryMaintenance: {
      title: 'Sorry',
      message: 'Momenteel kunnen wij uw overboeking niet verwerken.'
    },
    insufficientStartAmount: {
      title: 'Sorry',
      message: 'De limiet voor het overdrachtsbedrag is overschreden.'
    },
    startAmountOutOfRange: {
      title: 'Sorry',
      message: 'De limiet voor het overdrachtsbedrag is overschreden.'
    },
    nonAccountedLimitExceeded: {
      title: 'Sorry',
      message: 'De betaling kan niet worden verwerkt omdat de verkoper de maandelijkse verkooplimiet heeft bereikt.'
    }
  },
  confirmation: {
    pageTitle: 'Informatie over het betalingsproces',
    linkBack: 'Ik kom terug naar de site',
    linkBackTimeout: 'Keer terug naar de partnersite in',
    linkBackTimeoutTime: 'seconden',
    linkBackAutoRedirect: 'Deze pagina wordt automatisch doorgestuurd naar de partnerwebsite over {time} seconden. Interactie met de pagina stopt het aftellen.',
    linkBackTimerStopped: 'De automatische doorverwijzing is gestopt. Gebruik de knop Terug naar de site om terug te keren naar de partnerwebsite.',
    incorrectAmount: {
      header: 'Verkeerd bedrag',
      description: 'Wij hebben uw betaling niet overgemaakt naar de ontvanger, omdat het bedrag onjuist was.',
      description2: 'Klik op de knop om terug te keren naar de pagina en deze opnieuw uit te voeren. Vergeet niet om geen gegevens te wijzigen.'
    },
    multiplePaid: {
      header: 'Dubbele storting',
      description: 'De ontvanger heeft uw betaling twee keer ontvangen. Maak je geen zorgen: je krijgt je geld terug.',
      description2: 'Neem contact op met de ontvanger en bezorg hem een ​​betalingsbevestiging.'
    },
    negative: {
      header: 'Geen betaling',
      description: 'Er is een fout opgetreden tijdens het verwerken van uw betaling. Maar er gaat niets verloren.',
      description2: 'Klik op de knop om terug te keren naar de pagina en deze opnieuw uit te voeren.'
    },
    notFound: {
      header: 'Geen betaling',
      description: 'Er is een fout opgetreden tijdens het verwerken van uw betaling. Maar er gaat niets verloren.',
      description2: 'Klik op de knop om terug te keren naar de pagina en deze opnieuw uit te voeren.'
    },
    outdated: {
      header: 'Einde van de tijd',
      description: 'Wij hebben uw betaling niet overgemaakt naar de ontvanger.',
      description2: 'Klik op de knop om terug te keren naar de pagina en deze opnieuw uit te voeren.'
    },
    outdatedPaidNotRefunded: {
      header: 'Einde van de tijd',
      description: 'Wij hebben uw betaling niet overgemaakt naar de ontvanger. Als er geld van uw rekening is afgeschreven, hoeft u zich geen zorgen te maken. U ontvangt uw geld binnen enkele dagen terug.',
      description2: 'Klik op de knop om terug te keren naar de pagina en deze opnieuw uit te voeren.'
    },
    outdatedPaidRefunded: {
      header: 'Einde van de tijd',
      description: 'Wij hebben uw betaling niet overgemaakt naar de ontvanger. Als het geld van uw rekening is afgeschreven, hoeft u zich geen zorgen te maken: we hebben het al terugbetaald.',
      description2: 'Klik op de knop om terug te keren naar de pagina en deze opnieuw uit te voeren.'
    },
    pending: {
      header: 'In uitvoering',
      description: 'Wij verwerken uw betaling. Wij zullen u op de hoogte stellen wanneer het de ontvanger bereikt.'
    },
    positive: {
      header: 'Betaald',
      visaVideo: 'Advertentievideo afgespeeld na een succesvolle transactie',
      description: 'Wij hebben uw geld overgemaakt naar de ontvanger.',
      dccStatement: 'Ik heb de mogelijkheid gekregen om de valuta te kiezen die voor mijn betaling gebruikt zal worden. Ik heb de transactievaluta geselecteerd en ben akkoord gegaan met betaling in {currency} tegen de getoonde wisselkoers. Dynamische valutaconversie (DCC) wordt verzorgd door Autopay S.A.'
    }
  },
  messages: {
    accessForbidden: 'Geen toegang',
    internalServerError: 'Er is een onverwachte fout opgetreden. Probeer het later opnieuw.',
    validators: {
      required: 'Verplicht veld',
      pattern: 'Geef een geldige waarde op',
      blikCode: 'Voer de 6-cijferige BLIK-code in',
      emailRequired: 'Geef het juiste e-mailadres op',
      emailNotValid: 'Geef het juiste e-mailadres op',
      emailNotRecognized: 'Het opgegeven e-mailadres is niet geregistreerd',
      emailIdentityLookup: 'Het e-mailadres kon niet worden geverifieerd',
      emailLocked: 'Het opgegeven e-mailadres wordt tijdelijk geblokkeerd in het Mastercard-systeem',
      paywayRequired: 'Kies een bank om te betalen',
      creditCardRequired: 'Vul alle velden in',
      phoneRequired: 'Voer een geldig telefoonnummer in',
      regulationRequired: 'Accepteer de Algemene Voorwaarden',
      requiredConsent: 'Toestemming vereist',
      codeNotValid: 'De opgegeven code is niet geldig',
      codeAccountLocked: 'Het account is tijdelijk geblokkeerd',
      unknownError: 'Er is een onverwachte fout opgetreden'
    },
    validatorsAria: {
      required: 'Aandacht. Het formulierveld is niet ingevuld. Verplicht veld',
      pattern: 'Aandacht. Het veld bevat een ongeldige waarde.',
      blikCode: 'Aandacht. Voer de 6-cijferige BLIK-code in',
      emailRequired: 'Aandacht. Het e-mailveld is niet ingevuld. Geef het juiste e-mailadres op',
      emailNotValid: 'Aandacht. Uw e-mailadres bevat een fout. Geef het juiste e-mailadres op',
      emailNotRecognized: 'Aandacht. Het opgegeven e-mailadres is niet geregistreerd.',
      emailIdentityLookup: 'Aandacht. Het opgegeven e-mailadres kon niet worden geverifieerd.',
      emailLocked: 'Aandacht. Het opgegeven e-mailadres wordt tijdelijk geblokkeerd in het Mastercard-systeem.',
      paywayRequired: 'Aandacht. Betaling is niet geselecteerd. Kies een betaalmethode',
      creditCardRequired: 'Aandacht. Vul alle velden met creditcardgegevens in',
      phoneRequired: 'Aandacht. Het telefoonnummerveld bevat een fout. Voer een geldig telefoonnummer in.',
      codeNotValid: 'Aandacht. De opgegeven code is niet geldig.',
      codeAccountLocked: 'Aandacht. Het account is tijdelijk geblokkeerd.',
      unknownError: 'Aandacht. Er is een onverwachte fout opgetreden.'
    },
    success: {
      copy: 'Gekopieerd!',
      codeSent: 'De code is verzonden!'
    },
    errors: {
      getPdf: 'Kan PDF niet downloaden!',
      copy: 'Kopiëren is niet gelukt!',
      thankYouUpdate: 'Kan e-mailadres niet opslaan!',
      groupInactive: 'Op dit moment is het onmogelijk om een overdracht uit te voeren via de groep {groupName}. Selecteer een andere betaalmethode.',
      paywayInactive: 'Momenteel is het om technische redenen onmogelijk om een overboeking te doen vanaf de geselecteerde bank. Selecteer een andere bank of betaalmethode.',
      googlePayInactiveTitle: 'Google Pay is niet beschikbaar op dit apparaat',
      applePayInactiveTitle: 'Apple Pay is niet beschikbaar op dit apparaat',
      applePayCancelTitle: 'Betaling is niet voltooid',
      applePayCancel: 'Betaling is niet bevestigd. Probeer het opnieuw of kies een andere methode.',
      googlePayInactive: 'Helaas is Google Pay-betaling niet beschikbaar op uw apparaat.',
      applePayInactive: 'Apple Pay is beschikbaar voor mensen die Safari- en iOS-apparaten gebruiken.',
      codeNotSent: 'Kan de code niet opnieuw verzenden!',
      codeCounterExceeded: 'Het toegestane aantal pogingen is overschreden. Voer uw kaartgegevens handmatig in of gebruik een andere betaalmethode.'
    }
  },
  modal: {
    closeButton: 'Dichtbij',
    confirmButton: 'Ik begrijp'
  },
  configuration: {
    paywayGroups: {
      auto: {
        label: 'Terugkerende betaling',
        description: 'Vul de gegevens in van de kaart waarmee u betaalt. Automatische betalingen worden later van uw kaart afgeschreven.',
        labelInitWithRefund: 'Verificatie betaling',
        labelInitWithRefundOrange: 'Betaalkaart toevoegen',
        labelInitWithPayment: 'Kaartbetaling',
        descriptionInitWithRefund: 'Voer de gegevens in van de kaart die u wilt verifiëren voor toekomstige betalingen. In de volgende stap brengen we 1 PLN in rekening van de gegeven kaart om de juistheid van de gegevens te controleren. Na verificatie storten wij het bedrag terug.',
        descriptionInitWithPayment: 'Voer de gegevens in van de kaart die u gaat gebruiken om de transactie uit te voeren en verifieer deze tegelijkertijd voor toekomstige betalingen.'
      },
      blik: {
        label: 'BLIK',
        description: 'Betaal direct door de BLIK-code in te voeren, geen login of registratie'
      },
      blikAuto: {
        label: 'BLIK terugkerende betalingen',
        description: 'U kunt terugkerende BLIK-betalingen voor deze handelaar inschakelen, waarna daaropvolgende betalingen automatisch van uw rekening worden afgeschreven.'
      },
      card: {
        label: 'Kaartbetaling',
        description: 'Betaal met uw bankkaart'
      },
      pbl: {
        label: 'Online overdracht',
        description: 'Kies de bank waar u de betaling wilt doen',
        descriptionVerify: 'Online identiteitsverificatie',
        descriptionServiceVerify: 'Selecteer de bank waarmee u de onlinedienst kunt verifiëren'
      },
      visaMobile: {
        label: 'VisaMobiel',
        description: 'Visa Mobiele betaling'
      },
      wallet: {
        label: 'Google&nbsp;Pay | Apple&nbsp;Pay',
        description: 'Betaal zonder in te loggen op internetbankieren'
      },
      installments: {
        label: 'Betaling in termijnen',
        description: 'Betaal uw aankopen in handige termijnen.'
      },
      alior: {
        descriptionInfo1: 'Betaal uw aankopen in handige termijnen.',
        descriptionInfo2: '(controleer details)',
        aliorModal: {
          text1: 'Afhankelijk van de instellingen van de website waar u de aankoop doet, kunt u producten in termijnen aanschaffen in de volgende varianten:',
          text2: '<ul><li>10 termijnen 0%</li><li>20 termijnen 0%</li><li>van 3 tot 48 termijnen met maandelijkse kosten van 1% (volgens het representatieve voorbeeld gegeven voor een bepaalde transactie)</li></ul>'
        }
      },
      otp: {
        label: 'Betaal later',
        description: 'Koop nu en betaal later',
        descriptionInfo1Mwf: 'Betaal de factuur later - eenmalig tot 45 dagen of in meerdere gelijke termijnen',
        descriptionInfo1Ecommerce: 'Betaal later - eenmalig tot 45 dagen of in meerdere gelijke termijnen',
        descriptionInfo2Mwf: 'Informatie over de kredietbemiddelaar en de kosten',
        descriptionInfo2Ecommerce: 'Kosteninformatie',
        labelPayka: 'Hij is',
        descriptionPayka: 'Betaal de rekening later – eenmalig tot 30 dagen of in 4 gelijke termijnen <a href="" id="paykaShowInModal">Informatie over de kredietbemiddelaar en de kosten</a>',
        paykaModalMwf: {
          header1: 'Kennisgeving leningmakelaar',
          text1: 'Autopay S.A., met hoofdkantoor in Sopot, treedt op als leningmakelaar voor Paytree S.A., met hoofdkantoor in Gdansk, Polen (Lender), bevoegd om het leningaanbod aan klanten te presenteren en door te verwijzen naar de website van de Kredietverstrekker, inclusief de leningaanvraag. Ga voor meer informatie over de aanbieding naar: <a href="https://payka.pl/rahunki-domowe" target="_blank">Huishoudelijke rekeningen – Payka</a>.',
          header2: 'Kostendetails',
          text2: 'Betaal later - eenmalig tot 45 dagen of in meerdere gelijke termijnen. Kostengegevens voor een representatief voorbeeld: Terugbetaling binnen 45 dagen APR 0%; Aflossing op afbetaling APR 74,11%. Details van de aanbieding op: <a href="https://payka.pl" target="_blank">Payka.pl</a>'
        },
        paykaModalEcommerce: {
          header2: 'Kostendetails',
          text2: 'Betaal later - eenmalig tot 45 dagen of in meerdere gelijke termijnen. Kostengegevens voor een representatief voorbeeld: Terugbetaling binnen 45 dagen APR 0%; Aflossing op afbetaling APR 74,11%. Details van de aanbieding op: <a href="https://payka.pl" target="_blank">Payka.pl</a>'
        }
      },
      blikPayLater: {
        label: 'BLIK Betaal later',
        description: ''
      },
      companyPayments: {
        label: 'Zakelijke betaling',
        description: 'Stel uw betaaldatum voor zakelijke aankopen 30 dagen uit'
      },
      transfer: {
        label: 'Overdrachtsgegevens',
        description: 'Bestel een overschrijving met behulp van de opgegeven gegevens'
      },
      other: {
        label: 'Ander',
        description: ''
      }
    },
    mobileEvents: {
      statusDescription: {
        bankDisabled: 'Sorry. Momenteel kunnen wij uw overboeking niet verwerken. De geselecteerde bank is momenteel niet beschikbaar.',
        blockMultipleTransactions: 'Sorry. De transactie bestaat al en wacht op betaling.',
        blockPaidTransactions: 'Sorry. De transactie is al betaald. U kunt de betaling niet nogmaals uitvoeren.',
        canceledTransactions: 'De transactie waarvoor u probeert te betalen is geannuleerd en is niet beschikbaar. Start een nieuwe transactie.',
        declined: 'Weigering van autorisatie.',
        generalError: 'Er is een tijdelijk verbindingsprobleem opgetreden. Momenteel kunnen wij uw overboeking niet verwerken. Kom later terug.',
        insufficientStartAmount: 'Sorry. De limiet voor het overdrachtsbedrag is overschreden.',
        internalServerError: 'Oepss.. de bewerking is mislukt:(. We werken aan een oplossing van het probleem. Probeer het later opnieuw.',
        nonAccountedLimitExceeded: 'De betaling kan niet worden verwerkt omdat de verkoper de maandelijkse verkooplimiet heeft bereikt.',
        outdatedError: 'De tijd om de betaling af te ronden is verstreken..',
        paid: 'De transactie is succesvol afgerond.',
        paywayLoaded: 'De snelle overdrachtpagina is geladen',
        paywaylistLoaded: 'De pagina voor het selecteren van de betaalmethode is geladen'
      }
    }
  },
  maintenance: {
    text1: 'Er is een nieuwjaarsschoonmaak van de Autopay-betalingsgateway aan de gang, en als gevolg daarvan is het op dit moment niet mogelijk om betalingen te bestellen. Onze excuses voor het ongemak.',
    text2: 'De gateway gaat al op 16 januari om 10.00 uur weer live.',
    text3: 'Bedankt voor uw begrip.'
  },
  requiredParams: {
    accountHolderName: {
      label: 'Voer de gegevens van de accounteigenaar in',
      flowLabel: 'Accounteigenaar',
      placeholder: 'Voer de gegevens van de accounteigenaar in'
    },
    nip: {
      label: 'Voer uw belastingidentificatienummer in',
      flowLabel: 'KNEEP',
      placeholder: 'Voer uw belastingidentificatienummer in'
    },
    customerEmail: {
      label: 'Voer uw e-mailadres in',
      flowLabel: 'E-mailadres',
      placeholder: 'Voer uw e-mailadres in'
    },
    senderIban: {
      label: 'Vul uw IBAN in',
      flowLabel: 'IBAN',
      placeholder: 'Vul uw IBAN in'
    },
    shippingBuildingNumber: {
      label: 'Voer het gebouwnummer in',
      flowLabel: 'Gebouwnr.',
      placeholder: 'Gebouwnr.'
    },
    shippingPostalCode: {
      label: 'Voer postcode in',
      flowLabel: 'Postcode',
      placeholder: 'Postcode'
    },
    shippingStreetName: {
      label: 'Straat ingaan',
      flowLabel: 'Straat',
      placeholder: 'Straat'
    },
    shippingLastName: {
      label: 'Voer achternaam in',
      flowLabel: 'Achternaam',
      placeholder: 'Achternaam'
    },
    shippingCountryCode: {
      label: 'Voer land in',
      flowLabel: 'Land',
      placeholder: 'selecteer land'
    },
    shippingRegion: {
      label: 'Regio invoeren',
      flowLabel: 'Regio',
      placeholder: 'Regio'
    },
    shippingFlatNumber: {
      label: 'Voer appartementnummer in',
      flowLabel: 'Geschikt. Nee.',
      placeholder: 'Geschikt. Nee.'
    },
    shippingFirstName: {
      label: 'Voer de voornaam in',
      flowLabel: 'Voornaam',
      placeholder: 'Voornaam'
    },
    shippingCity: {
      label: 'Stad invoeren',
      flowLabel: 'Stad',
      placeholder: 'Stad'
    }
  },
  survey: {
    skipSurvey: 'Enquête overslaan',
    skipSurveyLabel: 'Enquêtesectie overslaan',
    sectionLabel: 'Enquête'
  }
}
